export default __webpack_public_path__ + "static/media/amazonses-negative.0e3bc66f.svg";